import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { BrandMark } from "@/components/BrandMark";

export function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <header className="sticky top-0 z-40 bg-[#120B19]/80 backdrop-blur-md border-b border-[#2E2140]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
        <Link to={user ? "/dashboard" : "/"} className="flex items-center gap-2 sm:gap-3 min-w-0" data-testid="nav-logo">
          <BrandMark size={44} className="shrink-0 hidden sm:block" />
          <BrandMark size={26} className="shrink-0 sm:hidden" />
          <div className="leading-none">
            <div className="font-serif text-[0.95rem] sm:text-xl tracking-[0.12em] sm:tracking-[0.24em] text-[#EDE6F7] whitespace-nowrap" data-testid="brand-wordmark">MEMORIES FOREVER</div>
            <div className="font-cormorant italic text-[0.95rem] sm:text-base tracking-[0.06em] text-[#B57BFF] mt-1" data-testid="brand-slogan">The Voices We Love</div>
          </div>
        </Link>
        <nav className="flex items-center gap-3">
          {user ? (
            <>
              {user.paid && <Link to="/dashboard" className="hidden sm:block text-[#B9B3C8] hover:text-[#EDE6F7] px-3 transition-colors" data-testid="nav-dashboard">
                Our Family
              </Link>}
              {user.role === "admin" && <Link to="/admin" className="hidden sm:block text-[#B9B3C8] hover:text-[#EDE6F7] px-3 transition-colors" data-testid="nav-admin">
                Admin
              </Link>}
              <button
                data-testid="nav-logout"
                onClick={() => { logout(); navigate("/"); }}
                className="ghost-gold h-11 px-4 sm:px-5 rounded-full text-sm whitespace-nowrap shrink-0"
              >
                Sign out
              </button>
            </>
          ) : (
            <button
              data-testid="nav-signin"
              onClick={() => navigate("/signin?mode=login")}
              className="ghost-gold h-11 px-4 sm:px-6 rounded-full whitespace-nowrap shrink-0"
            >
              Log in
            </button>
          )}
        </nav>
      </div>
      {user?.readonly && (
        <div className="bg-[#1E1428] border-t border-[#3B2D52] text-center text-sm text-[#B57BFF] py-2 px-4" data-testid="readonly-banner">
          Read-only view · signed in as {user.viewer?.name}. You can look and listen, but changes can't be saved.
        </div>
      )}
    </header>
  );
}
